import React from 'react';
import { Button, Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import PublishModalContent from '../../../PublishModalContent/PublishModalContent';
import OutboundLink from '../../../../../../atoms/OutboundLink/OutboundLink';
import { PlanPropType } from '../../../../../../services/proptypes';
import './LaunchCloverMarketplaceContent.css';
var defaultProps = {
  show: false
};
export default function LaunchCloverMarketplaceContent(_ref) {
  var show = _ref.show,
      onBackButtonClick = _ref.onBackButtonClick,
      cloverUrl = _ref.cloverUrl,
      plan = _ref.plan;
  var title = plan.title,
      monthly = plan.monthly;
  return /*#__PURE__*/React.createElement(PublishModalContent, {
    show: show,
    backButtonText: "Step 2/2",
    headerText: "Final Step",
    onBackButtonClick: onBackButtonClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "launch-clover-marketplace"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-text instructions"
  }, "To complete the checkout process, click the \u201CLaunch Clover Marketplace\u201D button below to install the Fisherman App. Once the app is installed, you will be brought to the Fisherman Dashboard where you can select your domain and edit your website."), !_isEmpty(plan) && /*#__PURE__*/React.createElement(Grid, {
    className: "plan-information-container"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 5,
    textAlign: "left",
    className: "body-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "bolded"
  }, "Plan:")), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 1
  }), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 10,
    textAlign: "left",
    className: "body-text"
  }, /*#__PURE__*/React.createElement("p", null, "".concat(title, " Package"))), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 5,
    textAlign: "left",
    className: "body-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "bolded"
  }, "Payment:")), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 1
  }), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 10,
    textAlign: "left",
    className: "body-text"
  }, /*#__PURE__*/React.createElement("p", null, "$".concat(monthly.price, "/ month")))), /*#__PURE__*/React.createElement(OutboundLink, {
    to: cloverUrl,
    className: "checkout-button-enabled centered-button",
    label: "Launch Clover Marketplace",
    as: Button
  })));
}
LaunchCloverMarketplaceContent.defaultProps = defaultProps;